import {CURRENCY} from '@/constant/currency';

export const CATEGORY_TYPES = {
  OFFICIAL: 'OFFICIAL',
  MASTER: 'MASTER',
};

export const CATEGORY_TYPE_LABELS = {
  OFFICIAL: '官方課程',
  MASTER: '大師課程',
};

export const OFFICIAL_MARKET = {
  HJJ_OFFICIAL_TW: 'HJJ_OFFICIAL_TW',
  HJJ_OFFICIAL_US: 'HJJ_OFFICIAL_US',
  HJJ_OFFICIAL_JP: 'HJJ_OFFICIAL_JP',
};

export const CURRENCY_MARKET_MAPPING = {
  [CURRENCY.TWD]: OFFICIAL_MARKET.HJJ_OFFICIAL_TW,
  [CURRENCY.USD]: OFFICIAL_MARKET.HJJ_OFFICIAL_US,
  [CURRENCY.JPY]: OFFICIAL_MARKET.HJJ_OFFICIAL_JP,
};

export const ITEM_TYPE = {
  COURSE_PLAN: 'coursePlan',
  VIP: 'vip',
  PHYSICAL_GOOD: 'physicalGood',
  STORED_VALUE_CARD: 'storedValueCard',
  LIVE_COURSE: 'liveCourse',
  LIVE_COURSE_UNIT_CARD: 'liveCourseUnitCard',
  VERIFICATION: 'verification',
  MC_TYPE: 'mcType',
};

export const SALE_PAGE_TAGS = {
  SHOW_IN_APP: 'SHOW_IN_APP',
  GO_PLUS: 'GO_PLUS',
  WCP_2026: 'WCP_2026',
  VIP: 'VIP',
  HOT_COURSE: 'HOT_COURSE',
  BUNDLE: 'BUNDLE',
  OFFICIAL_RECOMMENDATION_RANK_PREFIX: 'OFFICIAL_RECOMMENDATION-',
  OFFICIAL_RECOMMENDATION_COURSE_PREFIX: 'OFFICIAL_RECOMMENDATION_COURSE-',
};

export const PRODUCT_TAGS = {
  COURSE_PLAN: 'COURSE_PLAN',
  PHYSICAL: 'PHYSICAL',
  BUNDLE: 'BUNDLE',
  LIVE_COURSE: 'LIVE_COURSE',
  WCP_2026: 'WCP_2026',
  VIP: 'VIP',
  LIVE_COURSE_UNIT_CARD: 'LIVE_COURSE_UNIT_CARD',
  VERIFICATION: 'VERIFICATION',
  KINI: 'KINI',
  TGC: 'TGC',
  KGP: 'KGP',
  COOPERATION: 'COOPERATION',
  ITP: 'ITP',
  SVC: 'SVC',
  MC_TYPE: 'MC_TYPE',
};
export default {
  OFFICIAL_MARKET,
  CURRENCY_MARKET_MAPPING,

  CATEGORY_TYPES,
  CATEGORY_TYPE_LABELS,

  ITEM_TYPE,
  SALE_PAGE_TAGS,
  PRODUCT_TAGS,
};
